import { useEffect, useState } from 'react';
import { ModalInkPlansProps } from './types';
import { PrintPlanFeatures } from './PrintPlanFeatures/PrintPlanFeatures';
import { PrintPlansOptions } from './PrintPlansOptions/PrintPlansOptions';
import { PrintPlanCards } from './PrintPlanCards/PrintPlanCards';
import { CustomModal } from './styles';

const ModalInkPlans = ({
  id,
  isOpen,
  onClose,
  title,
  subtitle,
  features,
  printPlansTitle,
  initialModelPurpose,
  paperToggleLabel,
  paperAddOnLabel,
  showPaper,
  printPlans,
  onAnalytics,
}: ModalInkPlansProps) => {
  const [selectedModelPurpose, setSelectedModelPurpose] = useState(
    initialModelPurpose ?? printPlans[0].planModelPurpose
  );

  useEffect(() => {
    if (isOpen && initialModelPurpose) {
      setSelectedModelPurpose(initialModelPurpose);
    }
  }, [isOpen, initialModelPurpose]);

  const selectedPlan = printPlans.find(
    (plan) => plan.planModelPurpose === selectedModelPurpose
  );

  return (
    <CustomModal
      id={id || 'modal-ink-plans'}
      show={isOpen}
      onClose={onClose}
      title={title}
      closeButton
      footer={false}
    >
      <PrintPlanFeatures subtitle={subtitle} features={features} />

      <PrintPlansOptions
        title={printPlansTitle}
        printPlans={printPlans}
        selectedModelPurpose={selectedModelPurpose}
        setSelectedModelPurpose={setSelectedModelPurpose}
        onAnalytics={onAnalytics}
      />

      <PrintPlanCards
        selectedPlan={selectedPlan}
        paperToggleLabel={paperToggleLabel}
        paperAddOnLabel={paperAddOnLabel}
        showPaper={showPaper}
        onAnalytics={onAnalytics}
      />
    </CustomModal>
  );
};

export default ModalInkPlans;
